import React, { useEffect, useState } from 'react';
import './styles/App.css';
import { ethers } from "ethers";
import LegendNFT from "./utils/LegendNFT";
import twitterLogo from './assets/twitter-logo.svg';
import logo from './assets/logo100.png';

// Constants
const TWITTER_HANDLE = 'codeforests';
const TWITTER_LINK = `https://twitter.com/${TWITTER_HANDLE}`;

const CONTRACT_ADDRESS = {
  "matic" : "0xf3789118bd11aca7641e56906232cedf9702a2a7",
  "maticmum" : "0x6b96e660a23eeafa00c0fa77a74f6187de46df1e",
  "rinkeby" : "0xaA629BE88190fe2077b970aa02f52dA40cE98454"
}
const NETWORK_SCAN_URL = {
  "matic" : "https://polygonscan.com/",
  "maticmum" : "https://mumbai.polygonscan.com/",
  "rinkeby": "https://rinkeby.etherscan.io/"
}

const OPENSEA_COLLECTION_LINK = {
  "matic" : "https://opensea.io/collection/codeforests-legend",
  "maticmum" : "https://testnets.opensea.io/collection/codeforests-legend",
  "rinkeby": "https://testnets.opensea.io/collection/codeforests-legend-v2"
}

const App = () => {

  const [currentAccount, setCurrentAccount] = useState("");
  const [isMinting, setIsMinting] = useState(false);
  const [totalMinted, setTotalMinted] = useState("");
  const [totalSupply, setTotalSupply] = useState("");
  const [currentNetwork, setCurrentNetwork] = useState("");
  const [lastTxnHash, setLastTxnHash] = useState("");
  
  const targetChain = ["matic", "maticmum", "rinkeby"];
  const { ethereum } = window;  

  const shortenAddress = (str) => {
    return str.substring(0, 6) + "..." + str.substring(str.length - 4);
  }

  const checkIfSupportedNetowrk = (network) => {
    if (targetChain.includes(network.name)) {
      setCurrentNetwork(network.name)
      return true
    }
    setCurrentNetwork("unsupported")
    return false
  }

  const checkIfWalletConnected = async () => {
    
    if (!ethereum) {
      console.log("Metamask is not installed, please install it first");
      return;
    }
    
    const provider = new ethers.providers.Web3Provider(ethereum);
    const network = await provider.getNetwork();
    if (!checkIfSupportedNetowrk(network)) {
      return
    }

    const accounts = await ethereum.request({method : 'eth_accounts'});
    if (accounts.length !== 0) {
      setCurrentAccount(accounts[0]);
    } else {
      console.log("No authorized account found!");
    }
  }

  const connectWallet = async () => {
    try {
      if (!ethereum) {
        alert("Please install metamask first!");
        return;
      }
      const accounts = await ethereum.request({method : 'eth_requestAccounts'});
      setCurrentAccount(accounts[0]);
      console.log("current account set as " + accounts[0]);

    } catch (error) {
      console.log(error);
    }
  }


  const mintNFT = async () => {
    try {

      setIsMinting(true);
      const provider = new ethers.providers.Web3Provider(ethereum);
      const signer = provider.getSigner();

      await ethereum.enable();
      const connectedContract = new ethers.Contract(CONTRACT_ADDRESS[currentNetwork], LegendNFT.abi, signer);

      let txn = await connectedContract.makeLegendNFT();
      await txn.wait();
      
      setLastTxnHash(txn.hash)
      console.log("New NFT minted successfully!")
      
      let totalMinted = await connectedContract.getTotalNFTsMintedSoFar()
      setTotalMinted(totalMinted.toNumber());

    } catch(error) {
      console.log(error);
    } finally {
      setIsMinting(false);
    }

  }

  const getTotalMinted = async () => {    
    try {

      if(!ethereum) {
        alert("Please install metamask first!");
        return;
      }
      const provider = new ethers.providers.Web3Provider(ethereum);
      const network = await provider.getNetwork();      
      if (!checkIfSupportedNetowrk(network)) {
        return
      }

      const signer = provider.getSigner();  

      await ethereum.enable();
      const connectedContract = new ethers.Contract(CONTRACT_ADDRESS[currentNetwork], LegendNFT.abi, signer);

      const maxSupply = await connectedContract.totalSupply();
      setTotalSupply(maxSupply.toNumber());
      
      let totalNFTMinted = await connectedContract.getTotalNFTsMintedSoFar();
      setTotalMinted(totalNFTMinted.toNumber())

    } catch(error) {
      console.log(error);
    }
  }

  // UI

  const renderNotConnectedContainer = () => (
    <button onClick={connectWallet} className='cta-button connect-wallet-button'>
    Connect to Wallet
    </button>
  );

  const renderMintButton = () => (
    <div>
      <p className='sub-text-2'> Minted : {totalMinted} / Total: {totalSupply}</p>

      <button 
      onClick={mintNFT}
      disabled = {isMinting}
      className='cta-button mint-button'>
        {isMinting ? "Minting..." : " Mint Your NFT (Free) "}
      </button>
    </div>
  );

  useEffect(() => {

    checkIfWalletConnected();

    if (currentAccount) {
      getTotalMinted();
    }

    if(ethereum) {      
      ethereum.on('chainChanged', (chainId) => {
        window.location.reload();
      });
    }

    })
  
  const unsupportedNetwork = () => {
    return (
      <div className="unsupported-network">
        <h2>Please connect to Matic or Matic Mumbai or Rinkeby testnet</h2>
        <p>
          This dapp only works on the rinkeby, matic and matic mumbai network, please switch networks
          in your connected wallet.
        </p>
      </div>
    );
  }

  const renderTxnDetails = () => {
    let txnLink = `${NETWORK_SCAN_URL[currentNetwork]}/tx/${lastTxnHash}`
    return (
      <div className='txncontainer'>
        <a className='txn-text' 
        href={txnLink} 
        target="_blank"
        rel="noreferrer">
          Transaction Details: {lastTxnHash}
          </a>
      </div>
    );
  }

  const landingPage = () => {
    return (
      <header className="header">
            <img src={logo} className="App-logo" alt="logo" />
            <h2 className='gradient-text'>
              The Codeforests Legendary NFT 
            </h2>
            <div>
            <p className='sub-text-2'>
             {currentAccount ?  `Currently connected to : ${shortenAddress(currentAccount)}` : "" }
            </p>
            <p className='sub-text-2'>
              {currentNetwork ? `Network : ${currentNetwork.toUpperCase()}` : ""}
            </p>
            </div>               
            {currentAccount === "" ? renderNotConnectedContainer() : renderMintButton()}
            
            {lastTxnHash ? renderTxnDetails() : ""}

          </header>
    )
  }
 
  return (

    <div className="App">
      <div className='container'>
        <div className='header-container'>
        { !currentAccount &&  currentNetwork === "unsupported"? 
        unsupportedNetwork() : landingPage() }
        </div>
        <div className='footer-container'>
        <div>
            🌊 <a className="footer-text" 
            href={OPENSEA_COLLECTION_LINK[currentNetwork]}
            target="_blank"
            rel="noreferrer">
            View on OpenSea</a>
            </div>

            <img alt="Twitter Logo" className="twitter-logo" src={twitterLogo} />
            <a
              className="footer-text"
              href={TWITTER_LINK}
              target="_blank"
              rel="noreferrer"
            >{`built by @${TWITTER_HANDLE}`}</a>
        </div>
      </div>
    </div>
  );
}

export default App;
